import { Box, Flex, Heading, useColorModeValue } from '@chakra-ui/react'
import * as React from 'react'
import NextImage from 'src/common/NextImage'
import { useAccent3 } from 'src/modeAwareColors'
import { H3 } from 'src/typography/typography'
import ArrowIllustration from './arrowIllustration'
import CollaborateIllustration from './collaborateIllustration'
import { SignupLink } from './links'
import TextBlock from './textBlock'

const ProjectOwners = () => {
  const a3 = useAccent3()
  const opacity = useColorModeValue(1, 0.2)

  return (
    <Box w='100%'>
      <H3 color={a3}>
        Projectlink
      </H3>
      <Heading as='h1' textStyle='headline'>
        For industrial projects
      </Heading>
      <Flex
        py={12}
      >
        <TextBlock
          heading='Add your project'
          body='Add a few details and project requirements. You always own this data and control who see it.'
        />
        <Box />
      </Flex>
      <Box
        d={['block', 'block', 'flex']}
        alignItems='center'
        justifyContent='space-around'
        py={20}
      >
        <NextImage
          src='/images/down-arrow.svg'
          dimensions={[24, 139]}
          opacity={opacity}
        />
        <NextImage
          src='/images/projectlink-text-field.svg'
          dimensions={[363, 189]}
        />
      </Box>
      <TextBlock
        heading="Decide who it's for"
        body='Make your project private, and only invite the suppliers and builders you trust. Or cast a line and post it publically.'
        my={[4, 4, '80px']}
      />
      <Flex
        py={[0, 0, 12]}
        justifyContent='space-around'
      >
        <NextImage
          src='/images/double-arrows.svg'
          dimensions={[163, 529]}
          opacity={opacity}
        />
        <Flex
          flexDir='column'
          justify='space-between'
          mb={[0, 0, '-80px']}
        >
          <TextBlock
            heading='Engage your existing contacts'
            body='Projectlink makes it easy to send project notices or details to your existing contacts, individually or all at once.'
            my='80px'
          />
          <TextBlock
            heading='Engage new companies'
            body='We tell potential suppliers and builders about your project. You can chose what they see.'
          />
        </Flex>
      </Flex>
      <Flex
        justify='center'
        mx='auto'
        py={28}
      >
        <ArrowIllustration opacity={opacity} />
      </Flex>
      <Box
        d={['block', 'block', 'flex']}
        justifyContent='space-around'
      >
        <CollaborateIllustration />
        <TextBlock
          heading='Work together'
          body='Share documents, specs, or images. Project information and management is always at your fingertips.'
        />
      </Box>
      <Flex
        justify='center'
        mx='auto'
        py={28}
      >
        <ArrowIllustration opacity={opacity} />
      </Flex>
      <Heading
        as='h2'
        textStyle='headline'
        textAlign='center'
      >
        Close the deal
      </Heading>
      <Flex justify='center' py={28}>
        <SignupLink />
      </Flex>
    </Box>
  )
}

export default ProjectOwners
